/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetTransportsColorsIdQueryResponse, GetTransportsColorsIdPathParams, GetTransportsColorsId400 } from '../entities/GetTransportsColorsId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getTransportsColorsId } from '../api/getTransportsColorsId'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTransportsColorsIdQueryKey = (id: GetTransportsColorsIdPathParams['id']) => [{ url: '/transports/colors/:id', params: { id: id } }] as const

export type GetTransportsColorsIdQueryKey = ReturnType<typeof getTransportsColorsIdQueryKey>

export function getTransportsColorsIdQueryOptions(id: GetTransportsColorsIdPathParams['id'], config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getTransportsColorsIdQueryKey(id)
  return queryOptions<GetTransportsColorsIdQueryResponse, ResponseErrorConfig<GetTransportsColorsId400>, GetTransportsColorsIdQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getTransportsColorsId(id, config)
    },
  })
}

/**
 * @description Get all transport colors
 * @summary Get all transport colors
 * {@link /transports/colors/:id}
 */
export function useGetTransportsColorsId<
  TData = GetTransportsColorsIdQueryResponse,
  TQueryData = GetTransportsColorsIdQueryResponse,
  TQueryKey extends QueryKey = GetTransportsColorsIdQueryKey,
>(
  id: GetTransportsColorsIdPathParams['id'],
  options: {
    query?: Partial<QueryObserverOptions<GetTransportsColorsIdQueryResponse, ResponseErrorConfig<GetTransportsColorsId400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getTransportsColorsIdQueryKey(id)

  const query = useQuery(
    {
      ...(getTransportsColorsIdQueryOptions(id, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTransportsColorsId400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}